// extracted by mini-css-extract-plugin
export var buttonContainer = "_35-6";
export var centeredToolbar = "_35-4";
export var dashdraw = "_35-c";
export var emptyStateContainer = "_35-8";
export var emptyStateText = "_35-9";
export var flowEditor = "_35-0";
export var flowEditorContainer = "_35-7";
export var hovered = "_35-1";
export var leftPanel = "_35-3";
export var mainCanvasContainer = "_35-a";
export var minimap = "_35-b";
export var selectMode = "_35-2";
export var toolbarSeparator = "_35-5";